export const DISTRIBUTION_CENTER = 'DistributionCenter';
//# sourceMappingURL=distribution-center.js.map